const PIL_URLS: Record<string, string> = {
  tirzepatide: "https://titanverse-assets.s3.eu-west-2.amazonaws.com/pils/tirzepatide.pdf",
  semaglutide: "https://titanverse-assets.s3.eu-west-2.amazonaws.com/pils/semaglutide.pdf",
  oral_semaglutide: "https://titanverse-assets.s3.eu-west-2.amazonaws.com/pils/semaglutide-oral.pdf",
  liraglutide: "https://titanverse-assets.s3.eu-west-2.amazonaws.com/pils/liraglutide.pdf",
  mysimba: "https://titanverse-assets.s3.eu-west-2.amazonaws.com/pils/naltrexone-bupropion.pdf",
  orlistat: "https://titanverse-assets.s3.eu-west-2.amazonaws.com/pils/orlistat.pdf",
};

export function getPilUrl(drugId: string): string | null {
  return PIL_URLS[drugId] ?? null;
}
